const target = document.getElementById("mg-discount-target");
const tooltip = document.getElementById("mg-tooltip");
if (target && tooltip) {
  target.addEventListener("mouseover", () => {
    tooltip.style.display = "block";
    tooltip.style.top = target.offsetTop - tooltip.offsetHeight - 15 + "px";
    let width = target.offsetWidth - tooltip.offsetWidth;
    tooltip.style.left = target.offsetLeft + width / 2 + "px";
    tooltip.style.opacity = 1;
  });

  target.addEventListener("mouseout", () => {
    tooltip.style.display = "none";
  });
}

class MgCountdown extends HTMLElement {
  // melgeek custom countdown timer
  connectedCallback() {
    this.createCountdownElement();
    const daysElement = document.querySelector("#timer-content #days");
    const hoursElement = document.querySelector("#timer-content #hours");
    const minutesElement = document.querySelector("#timer-content #minutes");
    const secondsElement = document.querySelector("#timer-content #seconds");

    const updateCountdown = (d, h, m, s) => {
      daysElement.innerText = d;
      hoursElement.innerText = h;
      minutesElement.innerText = m;
      secondsElement.innerText = s;
    };

    const startTimer = () => {
      let currentDate = new Date().getTime();
      let deadline_value = this.getAttribute("deadline");
      deadline_value = deadline_value.replace(/-/g,"/");
      let deadline = new Date(deadline_value).getTime();

      if (currentDate >= deadline) {
        updateCountdown("00", "00", "00", "00");
        return;
      }

      let remainingDate = deadline - currentDate;

      let days = String(
        Math.floor(remainingDate / (1000 * 60 * 60 * 24))
      ).padStart(2, "0");
      let hours = String(
        Math.floor((remainingDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      ).padStart(2, "0");
      let minutes = String(
        Math.floor((remainingDate % (1000 * 60 * 60)) / (1000 * 60))
      ).padStart(2, "0");
      let seconds = String(
        Math.floor((remainingDate % (1000 * 60)) / 1000)
      ).padStart(2, "0");

      updateCountdown(days, hours, minutes, seconds);
    };

    setInterval(startTimer, 1000);
  }

  createCountdownElement() {
    const timerElement = document.createElement("div");
    timerElement.id = "timer-content";
    timerElement.innerHTML = `
        <div id="countdown">
            <div id="timer">
                <span id="timer-display">
                    <span class="time" id="days"></span> <span class="time" id="hours"></span>:<span class="time"
                        id="minutes"></span>:<span class="time" id="seconds"></span>
                </span>
            </div>
        </div>
        `;
    this.append(timerElement);
  }
}

customElements.define("mg-countdown-timer", MgCountdown);



  var toggleButtons = document.querySelectorAll('.mg-load-more-button');

  toggleButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      var content = this.previousElementSibling;
      var expanded = this.getAttribute('aria-expanded') === 'true';
      
      // 切换内容的展开状态
      content.classList.toggle('expanded');
      this.setAttribute('aria-expanded', !expanded);

      // 更新按钮文本
      this.textContent = expanded ? 'Show More >' : 'Show Less >';
    });
  });

